import httpClient, { httpFormDataClient } from "./httpClient.js";

export interface MissingBoxRecord {
  id: number;
  branch: { id: number; name: string };
  partner: {
    id: number;
    person?: {
      firstName?: string;
      lastName?: string;
      secondLastName?: string;
    };
  };
  incidentDate: number; // unix seconds
  totalMissingAmount: number | string;
  amountPerPeriod: number | string;
  startPeriodDate: number; // unix seconds
  endPeriodDate: number; // unix seconds
  note?: string;
  status: string;
  fortnights?: number;
  createdAt: string;
  updatedAt: string;
  missingBoxFiles?: Array<{
    id: number;
    file: { name: string; extension: string; url: string };
  }>;
}

export interface MissingBoxListParams {
  limit?: number;
  offset?: number;
  branchId?: number;
  partnerId?: number;
  order?: "ASC" | "DESC";
  sort?: string;
  param?: string;
  incidentDate?: string; // YYYY-MM-DD
}

export const getMissingBoxList = async (params: MissingBoxListParams) => {
  const { data } = await httpClient.get("/missing-box-partner", { params });
  return data as { data: MissingBoxRecord[]; total: number };
};

export interface CreateMissingBoxPayload {
  branchId: number;
  partnerId: number;
  incidentDate: number; // Unix timestamp
  totalMissingAmount: number;
  amountPerPeriod: number;
  startPeriodDate: number; // Unix timestamp
  endPeriodDate: number; // Unix timestamp
  note?: string;
  fortnights?: number;
}

export const createMissingBox = async (payload: CreateMissingBoxPayload) => {
  const { data } = await httpClient.post("/missing-box-partner", payload);
  return data as MissingBoxRecord;
};

export const getMissingBoxById = async (id: number) => {
  const { data } = await httpClient.get(`/missing-box-partner/${id}`);
  return data as MissingBoxRecord;
};

export const updateMissingBox = async (
  id: number,
  payload: Partial<CreateMissingBoxPayload> & { status?: string }
) => {
  const { data } = await httpClient.patch(`/missing-box-partner/${id}`, payload);
  return data as MissingBoxRecord;
};

export const deleteMissingBox = async (id: number) => {
  const { data } = await httpClient.delete(`/missing-box-partner/${id}`);
  return data as { message: string };
};

export const uploadFilesToMissingBox = async (id: number, files: File[]) => {
  const formData = new FormData();
  if (files && files.length > 0) {
    files.forEach((f) => formData.append('missingBoxFiles', f));
  }
  const { data } = await httpFormDataClient.post(`/missing-box-partner/${id}/files`, formData);
  return data as MissingBoxRecord;
};

export const deleteMissingBoxFile = async (fileId: number) => {
  const { data } = await httpClient.delete(`/missing-box-partner/files/${fileId}`);
  return data as { message: string };
};

export const getMissingBoxByPartner = async (partnerId: number) => {
  const { data } = await httpClient.get(`/missing-box-partner/by-partner/${partnerId}`);
  return data as MissingBoxRecord[];
};


